/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';

export const successResponseInterceptor = (
	response: AxiosResponse<any>
): AxiosResponse<any> | Promise<AxiosResponse<any>> => {
	return response;
};
